(() => {
  'use strict';
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 901px)');
  let paused = false, playing = false, frame = 0, scenes = [], active = new Set();
  let historySelection = new URL(location.href).searchParams.get('transmission');
  try { paused = localStorage.getItem('stillhigh-atmosphere-paused') === 'true'; } catch (_) {}
  const clamp = n => Math.min(1, Math.max(0, n));
  const motionAllowed = () => !paused && !reduced.matches && !navigator.connection?.saveData;
  const moving = () => motionAllowed() && !playing && !document.hidden;
  const reset = scene => scene.querySelectorAll('[data-shu-depth],[data-shu-portal]').forEach(plane => plane.style.removeProperty('transform'));
  const update = () => {
    frame = 0;
    if (!moving() || !desktop.matches) return;
    active.forEach(scene => {
      const rect = scene.getBoundingClientRect();
      const progress = clamp((innerHeight - rect.top) / (innerHeight + rect.height));
      scene.querySelectorAll('[data-shu-depth]').forEach(plane => {
        plane.style.transform = `translate3d(0,${((progress - .5) * 170 * Number(plane.dataset.shuDepth)).toFixed(2)}px,0)`;
      });
      const portal = scene.querySelector('[data-shu-portal]');
      if (portal) portal.style.transform = `scale(${1 + clamp(-rect.top / Math.max(1, rect.height - innerHeight)) * 1.7})`;
    });
  };
  const schedule = () => { if (!frame && moving()) frame = requestAnimationFrame(update); };
  const refresh = () => {
    root.dataset.shuMotion = motionAllowed() ? 'on' : 'off';
    const still = !moving();
    root.dataset.shAtmospherePaused = String(still);
    document.querySelectorAll('button[data-shu-motion]').forEach(button => {
      button.hidden = false;
      button.textContent = reduced.matches ? 'Reduced motion' : paused ? 'Resume scenery' : 'Pause scenery';
      button.setAttribute('aria-pressed', String(paused || reduced.matches));
      button.disabled = reduced.matches;
    });
    if (still || !desktop.matches) scenes.forEach(reset);
    window.dispatchEvent(new CustomEvent('stillhigh:motionchange', { detail: { paused: still } }));
    schedule();
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? active.add(entry.target) : active.delete(entry.target));
    schedule();
  }, { rootMargin: '100px' }) : null;
  const scan = () => {
    observer?.disconnect(); active.clear();
    scenes = [...document.querySelectorAll('[data-shu-scene]')];
    scenes.forEach(scene => observer ? observer.observe(scene) : active.add(scene));
    refresh();
  };
  const focusWatch = () => {
    const target = document.querySelector('[data-sh-tv-console]') || document.getElementById('watch');
    if (target) { target.focus({ preventScroll: true }); target.scrollIntoView({ behavior: 'auto', block: 'start' }); }
  };
  const restore = event => {
    const id = new URL(location.href).searchParams.get('transmission');
    const tv = document.querySelector('[data-sh-tv]');
    if (id === historySelection) return;
    historySelection = id;
    if (tv?._shSelectId) tv._shSelectId(id || tv.dataset.shInitialId, { history: false });
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const button = event.target.closest('button[data-shu-motion]');
    if (button) { paused = !paused; try { localStorage.setItem('stillhigh-atmosphere-paused', String(paused)); } catch (_) {} refresh(); return; }
    if (event.target.closest('[data-shu-shuffle]')) { document.querySelector('[data-sh-tv-shuffle]')?.click(); return; }
    const link = event.target.closest('a[data-shu-tune],a[data-sh-tv-jump]');
    const tv = document.querySelector('[data-sh-tv]');
    const lead = link?.dataset.shuLead || link?.dataset.shTvLead;
    if (link && tv?._shSelectId && tv._shSelectId(lead)) {
      event.preventDefault();
      const url = new URL(location.href); url.hash = 'watch'; history.replaceState(null, '', url);
      focusWatch(); return;
    }
    if (link && tv?._shTune) {
      event.preventDefault(); tv._shTune(link.dataset.shuTune || link.dataset.shTvJump, lead, {scroll:false}); focusWatch(); return;
    }
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.target || anchor.hasAttribute('download')) return;
    anchor.closest('.shu-nav-more')?.removeAttribute('open');
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash || url.search && url.search !== location.search) return;
    let id; try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) { return; }
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    // Preserve the selected transmission while moving between chapters.
    const destination = new URL(location.href); destination.hash = url.hash;
    history.pushState(null, '', destination);
    target.setAttribute('tabindex', target.getAttribute('tabindex') || '-1');
    target.focus({ preventScroll: true }); target.scrollIntoView({ behavior: 'auto', block: 'start' });
  });
  addEventListener('popstate', restore);
  addEventListener('stillhigh:channelchange', () => { historySelection = new URL(location.href).searchParams.get('transmission'); });
  addEventListener('stillhigh:playbackchange', event => { playing = !!event.detail.playing; refresh(); });
  addEventListener('stillhigh:tvready', restore);
  addEventListener('scroll', schedule, { passive: true, capture: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', refresh);
  reduced.addEventListener('change', refresh); desktop.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    scenes.filter(scene => event.target.contains(scene)).forEach(scene => { observer?.unobserve(scene); active.delete(scene); reset(scene); });
    scenes = scenes.filter(scene => !event.target.contains(scene));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
})();

